import React, { useRef } from 'react';

import { useParams, useNavigate } from 'react-router-dom'; // Import useLocation

import { useFolder } from '../../context/folder-context'; // Custom hook to use folder context

import Container from '../../components/blocks/container';
import ApplianceInfo from '../../components/folder-components/appliance/folder--appliance-info';
import WarrantyInfo from '../../components/folder-components/folder--warranty-info';
import ClientInfo from '../../components/folder-components/folder--client-info';
import FolderInfo from '../../components/folder-components/folder--folder-info';
import PartsInfo from '../../components/folder-components/folder--parts-info';
import DeclaredIssueInfo from '../../components/folder-components/issues/folder--declared-issue-info';
import AdditionalInfo from '../../components/folder-components/issues/folder--additional-info';
import AppointmentsInfo from '../../components/folder-components/appointments/folder--appointments-info';
import PaymentsOverview from '../../components/folder-components/payments/folder--payments--overview';

import CommonButton from '../../components/buttons/common-button';
import Undo from '@mui/icons-material/Undo';

/**
 * FolderOverviewPage Component
 * 
 * This component displays the folder overview page with all the information related to the folder.
 * @returns {JSX.Element} - Rendered component
 */
const FolderOverviewOnlyPage = () => {
    const { refFolder } = useParams(); // Get the folder number from the URL
    const navigate = useNavigate(); // Hook to programmatically navigate

    // Reference to the overview container
    const overviewRef = useRef();

    const { title, color } = useFolder(); // Get the title and color from the folder context

    // State to hold folder data
    return (
        <React.Fragment>
            <Container
                className="w-100 folder-container"
                title={title || ''}
                titleBackground={color || 'transparent'}
            >
                <div
                    ref={overviewRef}
                    className="overview-container"
                    id="folder-overview"
                >
                    {/* Folder Overview Page */}
                    <h1 className="folder-container--title">Rapport d'intervention N° {refFolder}</h1>

                    {/* Client Information Section */}
                    <ClientInfo 
                        enabledMapButtons={false}
                    />

                    {/* Folder Information Section */}
                    <FolderInfo />

                    {/* Appliance Information Section */}
                    <ApplianceInfo />

                    {/* Warranty Information Section */}
                    <WarrantyInfo />

                    {/* Declared and Observed Issues Section */}
                    <DeclaredIssueInfo />

                    {/* Additional Information Section */}
                    <AdditionalInfo />

                    {/* Appointments Section */}
                    <AppointmentsInfo />

                    {/* Spare Parts Section */}
                    <PartsInfo />

                    {/* Payments Section */}
                    <PaymentsOverview/>
                </div>

                {/* Display the form with the fields and submit buttons */}
                <CommonButton
                    icon={<Undo />}
                    label={'Retour'}
                    onClick={() => navigate(-1)} 
                />
            </Container>
        </React.Fragment>
    );
};

export default FolderOverviewOnlyPage;